import { useEffect } from 'react'
import { useCustomClaim } from '../../hooks/useCustomClaim'
import { useAuthContext } from '../../hooks/useAuthContext'
//import { useNavigate } from 'react-router-dom'
//import { useDocument } from '../../hooks/useDocument'
import { 
  dateObjToDateStr, 
  dateObjToTimestamp, 
  timestampToDateObj, 
  timestampToDateStr,
  dateStrToTimestamp,
  dateStrToDateObj,
  calculateDateObj
} from '../../hooks/useDateAndTime'

import styles from './Signup.module.css'

export default function LoggingIn() {
  const { setCustomClaim } = useCustomClaim()
  const { dispatch, user } = useAuthContext()
  //const { document : userInfo, error: userError } = useDocument('users', user.uid)
  //const navigate = useNavigate()
  const todayDate = new Date()

  /*const subscription = {
    start: dateObjToTimestamp(todayDate),
    end: calculateDateObj(todayDate, 10, 'weeks'),
    name: 'trial'
  }*/

  const loggingIn = async () => {

    try{

      const tenantId = 'demo' //userInfo.tenantId //(userInfo && userInfo.tenantId !== 'demo') ? userInfo.tenantId : 'demo'
      const accessLevel = [
        {department: 'finance', level: 'read' },
        {department: 'operation', level: 'read' },
        {department: 'sales', level: 'read' },
        {department: 'marketing', level: 'read' },
        {department: 'company', level: 'read' },
        {department: 'administrator', level: 'none' },
      ]
      await setCustomClaim ({ userUid: user.uid, tenantId: tenantId, accessLevel: accessLevel, /*subscription: subscription*/ })
      // dispatch set custom claims action
      const idTokenResult = await user.getIdTokenResult()
      dispatch({ type: 'SET_CUSTOM_CLAIMS', payload: idTokenResult.claims })

      // navigate away?
      //navigate('/signup/loggingin')


    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    loggingIn()
  }, [])
  
  

  return (
    <div>
      <h1>Hello {user.displayName}!</h1>
      <h3>Crifty team welcomes you</h3>
      <div className={styles['container']}>
        <p>For any bugs, 
          errors, or even suggestion and improvement ideas, 
          please drop us a message below or <a href="mailto:askme@crifty.com">email us</a>. Thank you 
          and once again welcome to a wonderful start of 
          proper, easy, simple bookkeeping you will ever need for your business journey.</p>
      </div>
    </div>
  )
}
